import React, { Fragment } from "react";
import LayoutWrpper from "./LayoutWrapper";
import LeftMenuAndHeader from '../LeftMenuAndHeader';
const defaultOpts = {showLeftMenu:true,contentClass:'page-content'};
const WithHeader = (Component,opt=defaultOpts) => {

  return ({path,...props}) => (
      <LayoutWrpper path={path}>
        <LeftMenuAndHeader {...(opt || defaultOpts)}>
          <Component {...props} />
        </LeftMenuAndHeader>
      </LayoutWrpper>
  );

};

export default WithHeader;
